<template>
  <Button v-if="user" @click="menu.toggle($event)" variant="text">
    <Avatar :image="avatarImage" :label="avatarLabel" shape="circle" />
  </Button>
  <Menu ref="menu" :model="menuItems" :popup="true" class="user-menu">
    <template #start>
      <div class="user-info-header p-3 border-b border-surface-300">
        <div class="flex items-center gap-3">
          <Avatar :image="avatarImage" :label="avatarLabel" shape="circle" size="large" />
          <div class="flex flex-col">
            <span class="font-semibold text-surface-900 dark:text-surface-0">
              {{ user?.displayName || 'User' }}
            </span>
            <span class="text-sm text-surface-600 dark:text-surface-400">
              {{ user?.email }}
            </span>
            <span
              v-if="organization?.name"
              class="text-xs text-surface-500 dark:text-surface-500 mt-1"
            >
              {{ organization.name }}
            </span>
          </div>
        </div>
      </div>
    </template>
  </Menu>
</template>

<script setup lang="ts">
import { useAuth } from '@/modules/auth/auth';
import Avatar from 'primevue/avatar';
import Button from 'primevue/button';
import Menu from 'primevue/menu';
import type { MenuItem } from 'primevue/menuitem';
import { computed, ref } from 'vue';
import { useRouter } from 'vue-router';

const { user, logout, stopImpersonating, impersonateUserId, organization } = useAuth();
const router = useRouter();

const menu = ref();

const menuItems = computed((): MenuItem[] => [
  ...(user.value?.superAdmin
    ? [
        {
          label: 'Users',
          icon: 'pi pi-users',
          command: () => router.push('/admin/users'),
        },
      ]
    : []),
  ...(impersonateUserId.value
    ? [
        {
          label: 'Stop impersonating',
          icon: 'pi pi-user-minus',
          command: () => stopImpersonating(),
        },
      ]
    : []),
  {
    label: 'Logout',
    icon: 'pi pi-sign-out',
    command: () => logout(),
  },
]);

const avatarImage = computed(() => {
  return user.value?.photoURL;
});

const avatarLabel = computed(() => {
  if (avatarImage.value) {
    return undefined;
  }
  return user.value?.displayName
    ?.split(' ')
    .map(name => name.charAt(0))
    .join('')
    .toUpperCase();
});
</script>
